import {Middleware, createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk';
import {combineReducers} from 'redux'


import SVTasksReducer from './SVTasksReducer'

/*


//import rootReducer from './reducerspwa/rootReducer'



*/
import SVReguserdetReducer from './SVReguserdetReducer'
import SVUsercreddetReducer  from './SVUsercreddetReducer'


import SVStoredcardlistReducer from './SVStoredcardlistReducer'
import SVStoredcarddetReducer from './SVStoredcarddetReducer'
//import SVAddresslistReducer from '../reducerspwa/SVAddresslistReducer'
import SVAddresslistReducer from './SVAddresslistReducer'
import SVAddressdetReducer from './SVAddressdetReducer'
import  RoomReducer from './RoomReducer'


import SVPwrresetReducer from './SVPwrresetReducer'
import SVReguserlistReducer from './SVReguserlistReducer'
/*may19 start*/
import SVCRReviewReducer from './SVCRReviewReducer'
/*may19 end*/
import SJPBReviewReducer from './SJPBReviewReducer';
import SHReviewReducer from './SHReviewReducer'
import SVReviewReducer from './SVReviewReducer'
import SVESOrderReducer from './SVESOrderReducer'
import SVOrderdetReducer from './SVOrderdetReducer'
import SVLocationDataReducer from './SVLocationDataReducer'
import SVFacetReducer from './SVFacetReducer'
import InvFacetReducer from './InvFacetReducer'

/*cosmos */
import SVFlyeviewReducer from '../redux_cosmos/SVFlyeviewReducer_cosmos'
import SVFlySearchReducer from './SVFlySearchReducer'
import SVFlyFacetReducer from './SVFlyFacetReducer'
import SVTPOrderReducer from './SVTPOrderReducer'
import SVTPOrderdetReducer from './SVTpOrderdetReducer'
import SOJSearchReducer from './SOJSearchReducer'
/*svdec15 start*/
/* not used delete
import CLISearchReducer from './CLISearchReducer';

*/
/*svdec15 end*/
import { reducer as reduxFormReducer } from 'redux-form'
//import createBrowserHistory from 'history/createBrowserHistory'
/*svdec18 */
import SVCliSearchReducer from './SVCliSearchReducer'
import {
    routerReducer,
    routerMiddleware,
  } from 'react-router-redux'
import { createBrowserHistory } from "history"

import SVESSearchReducer from './SVESSearchReducer'
import SJSojournReducer from './SJSojournReducer';
import SVCruisedetReducer from './SVCruisedetReducer';
import SVCruisefareReducer from './SVCruisefareReducer'

const { createLogger, } = require('redux-logger')

export const browserHistory = createBrowserHistory()

const middlewares = [
    thunk,
    routerMiddleware(browserHistory),
   
   
  ]

  if (process.env.NODE_ENV !== 'production') {
    /* Redux logger only in dev */
    // eslint-disable-next-line
    const { createLogger, } = require('redux-logger')
  
    const logger = createLogger({ collapsed: true, })
    middlewares.push(logger)
  }



/*
const Store = createStore(
    AllReducers,
    {},
    appliedMiddlewares,
  )
  
  export default Store
*/

const AllReducers = combineReducers({
   
   form:reduxFormReducer,
     svreguserdetView:SVReguserdetReducer,
    routing: routerReducer,
    movies: SVTasksReducer,

    svpwrresetView:SVPwrresetReducer,

    svreguserlistView:SVReguserlistReducer,

    svreguserdetView:SVReguserdetReducer,
    svstoredcarddetView:SVStoredcarddetReducer,
    svstoredcardlistView:SVStoredcardlistReducer,
    svaddressdetView:SVAddressdetReducer,
    roomdetView:RoomReducer,
    svaddresslistView:SVAddresslistReducer,

    svesorder: SVESOrderReducer,
    orderdetView:SVOrderdetReducer,
    reviewView:SVReviewReducer,
    sjreviewView:SHReviewReducer,
    /*aug1 start */
    sjpbreviewView:SJPBReviewReducer,
       /*aug1 end */
    svessearch: SVESSearchReducer,
    sosjournsearch: SOJSearchReducer,
    //cruisesearch:CLISearchReducer,
    locationDataView:SVLocationDataReducer,
    facetDataView:SVFacetReducer,
    invfacetDataView:InvFacetReducer,

    flyreviewView:SVFlyeviewReducer ,
    svflysearch:SVFlySearchReducer,
    /*svdec18*/
    
    cruisesearch : SVCliSearchReducer,
    /*svcrreviewReducer may19*/
    crreviewView:SVCRReviewReducer,
    /*svcrreviewReducer end may19*/

    /*svmar14 start */
    /*svclisearch:SVCliSearchReducer, */
    /*svmar14 end */
    flyfacetDataView : SVFlyFacetReducer,
    
    svtporder: SVTPOrderReducer,
    tporderdetView:SVTPOrderdetReducer,
    
    sojourDetailView:SJSojournReducer,
    cruiseDetailView:SVCruisedetReducer,

    /*s8svjuly17 start*/
    cruiseFareView:SVCruisefareReducer,
        /*s8svjuly17 end*/
    

 
    svusercreddetView:SVUsercreddetReducer

   

    
    
    
})

const appliedMiddlewaresSVSE = applyMiddleware(...middlewares)

/*
export default function configureStore(initialState){
    return createStore(AllReducers,initialState, applyMiddleware(thunk))
}
*/

export default function configureStore(initialState){
    return createStore(AllReducers,initialState, appliedMiddlewaresSVSE)
}